import styled from "styled-components";
import {Row, Card} from "antd";
export const ButtonContainer = styled.div`
    position: absolute;
    bottom: 20px;
    left: 15%;
    width: 70%;
`;

export const PasswordButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    gap: 20px;
`;

export const Container = styled(Row)`
    height: -webkit-fill-available;
`;

export const CardContainer = styled(Card)`
    flex: 1;
    height: 100vh;
`;
